/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_FailedInputs */



/**
* | output |
* | --- |
* | "Something went wrong sending your message. Please try again in a moment." |
*
* @param {Contact_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const contact_failed = /** @type {((inputs?: Contact_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("发送留言时出错，请稍后再试。")
	return /** @type {LocalizedString} */ ("Something went wrong sending your message. Please try again in a moment.")
});